import { useSelector } from 'react-redux';
import { RootState } from 'store';

const EmailHero = () => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);

  return (
    <div className="space-y-6">
      <span className="flex items-center gap-2">
        <img
          src={
            isDarkMode ? '/email-generator-dark.png' : '/email-generator.png'
          }
          className="max-h-[120px] md:max-h-[146px] h-full"
          alt="Email Generator"
        />
      </span>
      <div className="md:space-y-0 flex flex-col gap-2">
        <h1 className="text-2xl md:text-5xl font-medium text-text-primary lg:leading-[60px] md:max-w-[400px] mb-2">
          Welcome to <br className="hidden md:block" /> Email Generator
        </h1>
        <p className="text-sm lg:text-xl font-normal text-text-primary md:w-[400px] mb-6 lg:mb-0">
          Craft professional, engaging, and well-structured emails in seconds
          with our AI-powered Email Generator. Whether for work, marketing, or
          personal use, generate clear and compelling emails effortlessly. Save
          time and communicate effectively with ease!{' '}
        </p>
      </div>
    </div>
  );
};

export default EmailHero;
